<template>
  <div class="my-balance">
    <div class="section-title">我的余额</div>

    <!-- 余额信息 -->
    <div class="balance-info">
      <div class="info-item">
        <div class="label">总资产(元)</div>
        <div class="value">0.00</div>
      </div>
      <div class="info-item">
        <div class="label">累计充值(元):</div>
        <div class="value">0</div>
      </div>
      <div class="info-item">
        <div class="label">累计消费(元):</div>
        <div class="value">0.00</div>
      </div>
    </div>

    <!-- 账单明细 -->
    <div class="bill-details">
      <el-tabs v-model="activeTab">
        <el-tab-pane label="账单明细" name="bill">
          <empty-component text="暂无账单明细哦~"></empty-component>
        </el-tab-pane>
        <el-tab-pane label="收入明细" name="income">
          <empty-component text="暂无收入明细哦~"></empty-component>
        </el-tab-pane>
        <el-tab-pane label="支出明细" name="expense">
          <empty-component text="暂无支出明细哦~"></empty-component>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import EmptyComponent from './EmptyComponent.vue'

export default {
  name: 'MyBalance',
  components: {
    EmptyComponent
  },
  data() {
    return {
      activeTab: 'bill'
    }
  }
}
</script>

<style lang="scss" scoped>
.my-balance {
  .section-title {
    font-size: 20px;
    font-weight: bold;
    color: #333;
    margin-bottom: 20px;
    text-align: left;
  }

  .balance-info {
    display: flex;
    justify-content: space-between;
    background-color: #fff;
    padding: 30px;
    border-radius: 4px;
    margin-bottom: 20px;

    .info-item {
      text-align: center;

      .label {
        font-size: 14px;
        color: #666;
        margin-bottom: 10px;
      }

      .value {
        font-size: 24px;
        color: #333;
        font-weight: bold;
      }
    }
  }

  .bill-details {
    background-color: #fff;
    border-radius: 4px;
    padding: 20px;

    :deep(.el-tabs__nav-wrap::after) {
      height: 1px;
    }

    :deep(.el-tabs__active-bar) {
      height: 2px;
    }
  }
}
</style>
